import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "defaultActiveIndexes", "exclusive"];
import React, { useState } from 'react';
import { Accordion as SemanticUiAccordion } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { ACCORDION_CONTENT_DISPLAY_NAME, ACCORDION_TITLE_DISPLAY_NAME } from './Accordion.constants';
import { AccordionContextProvider } from './Accordion.context';
import { getInitialActiveIndexes, getNextActiveIndexes, injectUncontrolledProps, isAccordionControlled } from './Accordion.utils';
import Content from './components/Content/Content';
import Title from './components/Title/Title';
import { findComponentsByType } from '../../../../services/components';
import useSemanticUiProps from '../../hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../types/component';
var defaultProps = {
  defaultActiveIndexes: [],
  exclusive: true // only allow one panel open at a time.
};
export default function Accordion(_ref) {
  var children = _ref.children,
    defaultActiveIndexes = _ref.defaultActiveIndexes,
    exclusive = _ref.exclusive,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getAccordionProps = _useSemanticUiProps.getAccordionProps;
  var _useState = useState(getInitialActiveIndexes(defaultActiveIndexes)),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndexes = _useState2[0],
    setActiveIndexes = _useState2[1];
  var titleComponents = findComponentsByType(children, ACCORDION_TITLE_DISPLAY_NAME);
  var contentComponents = findComponentsByType(children, ACCORDION_CONTENT_DISPLAY_NAME);
  var isControlled = isAccordionControlled(titleComponents, contentComponents);
  function onTitleClick(e, data) {
    var index = data.index;
    setActiveIndexes(function (previousActiveIndexes) {
      return getNextActiveIndexes(previousActiveIndexes, index, exclusive);
    });
  }
  var finalContent = isControlled ? children : injectUncontrolledProps(children, activeIndexes, onTitleClick);
  if (_isEmpty(finalContent)) {
    return null;
  }
  var contextValue = {
    isControlled: isControlled,
    onTitleClick: onTitleClick,
    activeIndexes: activeIndexes
  };
  return /*#__PURE__*/React.createElement(AccordionContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(SemanticUiAccordion, _extends({}, getAccordionProps(props), {
    exclusive: exclusive
  }), finalContent));
}
Accordion.defaultProps = defaultProps;
Accordion.Content = Content;
Accordion.Title = Title;